import theme from "app/Theme/Theme";
import React from "react";
import Svg, { Path } from "react-native-svg";

const ActionIcon = ({
  width = 10,
  height = 17,
  color = theme.colors["neutral.white"],
  style = {},
}) => {
  return (
    <Svg
      style={style}
      width={width}
      height={height}
      viewBox="0 0 10 17"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M9.70964 6.43856C9.61789 6.29621 9.46033 6.21159 9.29179 6.21159H5.80138V0.736424C5.80138 0.50149 5.63683 0.298411 5.40646 0.249632C5.1721 0.199858 4.94273 0.320311 4.847 0.534341L0.857952 9.4937C0.789141 9.64701 0.8041 9.82619 0.895848 9.96656C0.987596 10.1079 1.14516 10.1935 1.3137 10.1935H4.80411V15.6687C4.80411 15.9036 4.96866 16.1067 5.19903 16.1555C5.23393 16.1625 5.26884 16.1664 5.30275 16.1664C5.49621 16.1664 5.67672 16.0539 5.75849 15.8708L9.74754 6.91142C9.81535 6.75712 9.80239 6.57992 9.70964 6.43856Z"
        fill={color}
      />
    </Svg>
  );
};

export default ActionIcon;
